import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {NavbarSearchPropTypes, CoursePropTypes} from "../../../utils/propTypes";

class CourseList extends Component {
    getCourses() {
        let courses = this.props.courses;

        if (this.props.search.type === 'COURSE' && this.props.search.query.length > 0) {
            courses = this.props.search.courses;
        }
        return courses;
    }

    render() {
        const doPluralize = (count, noun, suffix = 's') =>
            `${count} ${noun}${count !== 1 ? suffix : ''}`;

        const courses = this.getCourses();
        let componentToRender = null;

        if (courses.length === 0) {
            componentToRender = (<a href="/courses/create/">
                <li className="course emptystate">
                    <div className="li__overlay">
                        <span className="li__title">
                            {"We couldn't find anything"}
                        </span>
                        <div className="li__subtitle">
                            {"Would you like to add new course? Tap here to add the course."}
                        </div>
                    </div>
                </li>
            </a>);
        } else {
            componentToRender = this.getCourses().map((course) => {
                let distance = null;
                // When the course doesn't have latitude and longitude specified, then the distance here is null
                if (course.distance != null) {
                    distance = <span>{parseFloat(course.distance).toFixed(1)} km</span>;
                }
                return (
                    <li
                        className="course"
                        key={course.id}
                        style={{backgroundImage: `url(${course.image_url})`}}
                        onClick={() => this.props.selectCourse(course.id)}
                    >
                        <div className="li__overlay">
                            <span className="li__title">{course.name}</span>
                            <div className="li__subtitle">
                                <span>Par {course.par}</span>
                                <span>{doPluralize(course.tee_count, 'basket')}</span>
                                {distance}
                            </div>
                        </div>
                    </li>
                );
            });
        }

        let loadingIndicatorClasses = 'list__loading-indicator';
        if (this.props.loadingIndicator) {
            loadingIndicatorClasses = 'list__loading-indicator list__loading-indicator--show';
        }

        return (
            <ul className="list--lg list--lg--loading">
                <div className={loadingIndicatorClasses}>
                    <div className="spinner">
                        <div className="rect1" />
                        <div className="rect2" />
                        <div className="rect3" />
                        <div className="rect4" />
                        <div className="rect5" />
                    </div>
                </div>
                {componentToRender}
            </ul>
        );
    }
}

CourseList.propTypes = {
    selectCourse: PropTypes.func.isRequired,
    courses: PropTypes.arrayOf(CoursePropTypes),
    search: NavbarSearchPropTypes,
    loadingIndicator: PropTypes.bool.isRequired,
};

export default CourseList;



// WEBPACK FOOTER //
// ./src/apps/create_game/components/CourseList.js